import { render } from "./AgentePickCentro.vue?vue&type=template&id=693f31b5"
import script from "./AgentePickCentro.vue?vue&type=script&lang=ts"
export * from "./AgentePickCentro.vue?vue&type=script&lang=ts"
script.render = render

export default script